module.exports = __webpack_public_path__ + "assets/img/clerk_img02.ec041dc9.png";